import { Action } from '@reduxjs/toolkit';
import { StateObservable } from 'redux-observable';
import {
  of, interval, EMPTY, Observable,
} from 'rxjs';
import {
  delayWhen, first, switchMap, map, filter,
} from 'rxjs/operators';

import { authActions, dialogActions } from '../../actions';
import { REALITY_CHECK_DIALOG } from '../../constants/dialog';
import { userRCISelector, dialogSelector } from '../../selectors';
import { RootState } from '../../types';

const { auth } = authActions;
const { dialog } = dialogActions;

function realityCheckIntervalEpic(action$: Observable<Action>, state$: StateObservable<RootState>) {
  return action$.pipe(
    filter(auth.success.match),
    switchMap(() => state$.pipe(first(), map(userRCISelector))),
    switchMap((rci) => (rci ? interval(rci * 60 * 1000) : EMPTY)),
    switchMap(() => state$.pipe(first(), map(dialogSelector))),
    switchMap((existingDialog) => of(dialog.add({ name: REALITY_CHECK_DIALOG })).pipe(
      delayWhen(() => (existingDialog ? action$.pipe(filter(dialog.remove.match), first()) : of(null)))
    )),
  );
}

export default realityCheckIntervalEpic;
